import {
  AutocompleteArrayInput,
  type AutocompleteArrayInputProps,
} from "react-admin";

import { useClientAppAllowedLandings } from "./useClientAppAllowedLandings";

type Props = Omit<AutocompleteArrayInputProps, "resource"> & {
  selectedClientAppId?: string;
};

export const ClientAppAllowedLandings = ({
  selectedClientAppId,
  ...rest
}: Props) => {
  const { allowedLandings, isLoading } =
    useClientAppAllowedLandings(selectedClientAppId);

  return (
    <AutocompleteArrayInput
      {...rest}
      choices={allowedLandings}
      isLoading={isLoading}
      optionText="title"
      optionValue="@id"
    />
  );
};
